import { useActiveParams, useParams } from "../hooks";
function createRoute() {
  return {
    useParams: function useParams1() {
      return useParams();
    },
    useActiveParams: function useActiveParams1() {
      return useActiveParams();
    },
    /**
    * Creates a typed loader function for this route.
    * The loader receives LoaderProps with typed params.
    *
    * @example
    * const route = createRoute<'(site)/docs/[slug]'>()
    * export const loader = route.createLoader(({ params }) => {
    *   // params is typed as { slug: string }
    *   return { doc: getDoc(params.slug) }
    * })
    */
    createLoader: function createLoader(fn) {
      return fn;
    }
  };
}
var defaults = createRoute();
var getProxy = function getProxy1() {
  return new Proxy({}, {
    get(target, key) {
      if (Reflect.has(defaults, key)) {
        return Reflect.get(defaults, key);
      }
      return getProxy();
    }
  });
};
var postIdRoute = createRoute();
var route = getProxy();
export {
  createRoute,
  route
};
//# sourceMappingURL=createRoute.js.map
